<template>
  <div class="top_icon_area">
    <TopIcon
      v-for="(icon, key) in icons"
      :key="key"
      :icon="icon"
      class="icon"
    ></TopIcon>
  </div>
</template>

<script>
import TopIcon from '@/components/atoms/TopIcon.vue';

export default {
  components: {
    TopIcon,
  },

  data: () => ({
    icons: [
      {
        image: '/img/icons/gacha24.png',
        url: 'https://wanana.iranoan.com/',
        text: 'Gacha24',
        target: 'blank',
      },
      {
        image: '/img/icons/gachamo.png',
        url: 'https://gachamo.com/',
        text: 'ガチャモ',
        target: 'blank',
      },
      {
        image: '/img/icons/hoppy.png',
        url: 'https://hoppy-gacha-iranoan.com/',
        text: 'ホッピー',
        target: 'blank',
      },
      {
        image: '/img/icons/yuly.png',
        url: 'https://yugioh.only.iranoan.com/',
        text: 'ユウリー',
        target: 'blank',
      },
      {
        image: '/img/icons/jgacha.png',
        url: 'https://jgacha.iranoan.com/',
        text: 'jガチャ',
        target: 'blank',
      },
      {
        image: '/img/icons/get24.png',
        url: 'https://get24-tcg.com/',
        text: 'Get24',
        target: 'blank',
      },
      {
        image: '/img/icons/gachaichi.png',
        url: 'https://gachaichi.jp/',
        text: 'ガチャイチ',
        target: 'blank',
      },
      {
        image: '/img/icons/gachaichi_town.png',
        url: 'https://town.gachaichi.jp/',
        text: 'ガチャイチタウン',
        target: 'blank',
      },
      {
        image: '/img/icons/point_exchange.png',
        url: '/transfer-point',
        alert: 'システムメンテナンス中のため現在ご利用いただけません。',
        text: 'ポイント移行',
        target: '',
      },
      {
        image: '/img/icons/card_coin.png',
        url: '/exchange-card',
        text: '引換所',
        target: '',
      },
      {
        image: '/img/icons/friend.png',
        url: '/change-member',
        text: '友達紹介',
        target: '',
      },
      // {
      //   image: '/img/icons/melpay.png',
      //   url: '/buy-point',
      //   text: 'メルペイ等で購入',
      //   target: '',
      // },
      {
        image: '/img/icons/purchase_table.png',
        url: 'https://www.iranoan.com/product-buys',
        text: '買取表',
        target: 'blank',
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.top_icon_area {
  display: flex;
  flex-wrap: wrap;
  max-width: 1080px;
  justify-content: center;
  margin: auto;
  margin-bottom: 20px;
  .icon {
    margin: 10px;
  }
}
@media screen and (max-width: $tabletWidth) {
  .top_icon_area {
    max-width: 360px;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
